import { BP_BOOKING_KEY, BP_BOOKING_PARAMS } from "../../../constants/balance-payments";
import SessionDataManager from "../../../util/storage-manager";
import { uuid } from "../../../util/basket";

export default class BalancePaymentLogin {
  constructor(context) {
    this.context = context;
    this.bookingPrefix = context.dataset.bookingPrefix;
    // set default siteName
    this.siteName = "sovereign";
    this.isAmhols = false;
    this.bookingRefInput = null;
    this.init();
  }

  init() {
    const htmlDataset = document.querySelector("html").dataset;
    if (htmlDataset) {
      this.siteName = htmlDataset.siteName;
      this.isAmhols =
        this.siteName === "americanholsie" ||
        this.siteName === "americanholscom";
    }
    // Set pattern of booking ID input on american holidays dynamically
    this.bookingRefInput = this.context.querySelector(
      '[data-element="booking-reference-input"]'
    );
    // On Amhols Regex is a string starting with the booking prefix
    // letter (case-insensitive) and ending with 7 numbers
    if (this.isAmhols && this.bookingPrefix) {
      const allowedLetters = JSON.parse(this.bookingPrefix);
      if (allowedLetters.length > 0) {
        const letters = allowedLetters.map((letter) => `${letter}${letter.toLowerCase()}`).join('');
        this.bookingRefInput.setAttribute(
          "pattern",
          `([${letters}]{1}[0-9]{7})$`
        );
      };
    }
    // Submission handler
    const submitButton = this.context.querySelector('[data-element="submit"]');
    submitButton.addEventListener("click", () => this.onFormSubmit());
    this.context.querySelectorAll("input").forEach((el) => {
      el.addEventListener("keydown", this.handleEnter.bind(this));
    });
  }

  handleEnter(e) {
    if (e.code === "Enter") {
      this.onFormSubmit();
    }
  }

  onFormSubmit() {
    const lastNameInput = this.context.querySelector(
      '[data-element="lead-passenger-surname-input"]'
    );
    const departureDateInput = this.context.querySelector(
      '[data-element="departure-date-input"]'
    );

    const correctPrefix =
      this.bookingPrefix &&
      this.bookingRefInput.value.charAt(0).toLowerCase() !==
        this.bookingPrefix.toLowerCase();

    const americanHolsValidation =
      correctPrefix && this.bookingRefInput.value.length !== 8;

    if (
      this.bookingRefInput.value === "" ||
      lastNameInput.value === "" ||
      departureDateInput.value === "" ||
      (this.isAmhols && americanHolsValidation)
    ) {
      this.context.classList.add("was-validated");
      return;
    } else if (this.context.classList.contains("was-validated")) {
      this.context.classList.remove("was-validated");
    }

    const searchParams = {
      bookingReference: this.bookingRefInput.value,
      lastName: lastNameInput.value,
      departureDate: departureDateInput.value,
      Context: {
        TraceSession: uuid()
      }
    };

    const stringifiedSearchParams = JSON.stringify(searchParams);

    const validationEl = this.context.querySelector(
      '[data-element="login-validation-not-found"]'
    );

    let headers = new Headers();
    headers.set("Content-Type", "application/json");
    return fetch("/api/Booking/GetBooking", {
      method: "post",
      body: stringifiedSearchParams,
      headers: headers,
      credentials: "include",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.BookingRecallSuccess) {
          // Save the user's last name so we can request the data again on the summary page
          SessionDataManager.setStorageItem(BP_BOOKING_PARAMS, stringifiedSearchParams);

          validationEl.classList.remove("active");
          SessionDataManager.setStorageItem(BP_BOOKING_KEY, JSON.stringify(responseJson));
          const paymentDetailsPage =
            this.context.dataset.balancePaymentDetailsPage;
          window.top.location.href = paymentDetailsPage;
        } else {
          validationEl.classList.add("active");
        }
      })
      .catch((response) => {
        console.error("Getting booking failed.");
        validationEl.classList.add("active");
      });
  }
}
